let reportBook = [
  {
    path: '/query_report',
    name: '体检报告',
    component: () => import('@/pages/report/registration_hospital_report')
  },
  {
    path: '/query_report_v3',
    name: '体检报告',
    component: () => import('@/pages/report/registration_hospital_report_v3')
  },
  {
    path: '/report_query_details',
    name: '体检报告详情',
    component: () => import('@/pages/report/registration_hospital_report_detail')
  },
  {
    path: '/report_query_kunhua',
    name: '体检报告查询',
    component: () => import('@/pages/report/report_query_kunhua')
  },
  {
    path: '/report_list_kunhua',
    name: '体检报告列表',
    component: () => import('@/pages/report/report_list_kunhua')
  },
  {
    path: '/report_detail_kunhua',
    name: '体检报告详情',
    component: () => import('@/pages/report/report_detail_kunhua')
  },
  {
    path: '/item_detail_kunhua',
    name: '体检项目详情',
    component: () => import('@/pages/report/item_detail_kunhua')
  },
  {
    path: '/report_pdf_kunhua',
    name: '图文报告',
    component: () => import('@/pages/report/report_pdf_kunhua')
  },
  {
    path: '/report_pdf_kunhua_download',
    name: 'pdf报告下载',
    component: () => import('@/pages/report/report_pdf_kunhua_download')
  },
  {
    path: '/report_query_details_v3',
    name: '体检报告详情',
    component: () => import('@/pages/report/registration_hospital_report_detail_v3')
  },
  {
    path: '/report_query_info',
    name: '选择就诊人',
    component: () => import('@/pages/report/info')
  },
  {
    path: '/report_query_info_v3',
    name: '选择就诊人',
    component: () => import('@/pages/report/info_v3')
  }
]

export default reportBook
